<div id="wrapper" [style]="'width:' + width + 'px;height:' + height + 'px'" #wrapper [class]="class"></div>
